import { Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import loadable, { LoadableComponent } from '@loadable/component';

import { Loader } from 'src/components/LayoutComponents/Loader';
import { IndexLayout } from 'src/layouts';
import { PageNotFound } from 'src/pages/404';

const loadableComponent = (importStatement: () => Promise<any>): LoadableComponent<any> =>
  loadable(importStatement, { fallback: <Loader /> });

const paths = {
  USER_LOGIN: '/user/login',
  USER_FORGOT: '/user/forgot',
  USA_MIGRATION: '/usa-migration',
  DASHBOARD_WAHED: '/dashboard/wahed',
  DASHBOARD_APPLICANT: '/dashboard/applicant/:id',
  NEW_PASSWORD: '/pages/newpassword',
};

const routes = [
  // System Pages
  {
    path: paths.USER_LOGIN,
    component: loadableComponent(() =>
      import('src/pages/user/login').then((module) => module.Login),
    ),
    exact: true,
  },
  {
    path: paths.USER_FORGOT,
    component: loadableComponent(() =>
      import('src/pages/user/forgot').then((module) => module.Forgot),
    ),
    exact: true,
  },
  // US migration
  {
    path: paths.USA_MIGRATION,
    component: loadableComponent(() =>
      import('src/pages/USAMigration').then((module) => module.USMigration),
    ),
    exact: true,
  },

  // Dashboards
  {
    path: paths.DASHBOARD_WAHED,
    component: loadableComponent(() =>
      import('src/pages/dashboard/wahed').then((module) => module.WahedDashboardPage),
    ),
  },
  {
    path: paths.DASHBOARD_APPLICANT,
    component: loadableComponent(() =>
      import('src/pages/dashboard/applicant').then((module) => module.DashboardApplicant),
    ),
  },

  {
    path: paths.NEW_PASSWORD,
    component: loadableComponent(() =>
      import('src/pages/NewPassword').then((module) => module.NewPassword),
    ),
    exact: true,
  },
];

export const Router = ({ history }: { history: any }) => {
  return (
    <ConnectedRouter history={history}>
      <IndexLayout>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/user/login" />} />
          {routes.map((route) => (
            <Route
              path={route.path}
              component={route.component}
              key={route.path}
              exact={route.exact}
            />
          ))}
          <Route component={PageNotFound} />
        </Switch>
      </IndexLayout>
    </ConnectedRouter>
  );
};
